import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=7acf30be&scoped=true"
import script from "./brandDetail.vue?vue&type=script&lang=js"
export * from "./brandDetail.vue?vue&type=script&lang=js"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=7acf30be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acf30be",
  null
  
)

export default component.exports